"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.47mm",
    height: "8.47mm",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.5,11h10a.5.5,0,0,0,.5-.5A10.51,10.51,0,0,0,13.5,0a.5.5,0,0,0-.5.5v10A.5.5,0,0,0,13.5,11Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,12h-10a.5.5,0,0,0-.35.85l7.07,7.07a.48.48,0,0,0,.7,0A10.4,10.4,0,0,0,24,12.5.5.5,0,0,0,23.5,12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,13.29V3.5a.5.5,0,0,0-.5-.5,10.5,10.5,0,0,0,0,21,10.4,10.4,0,0,0,7.42-3.08.48.48,0,0,0,0-.7Z",
    transform: "translate(0 0)"
  })));
};

exports["default"] = _default;